import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useIsFilterReady() {
	const [searchParams] = useSearchParams();

	const readyForQuery = useMemo(() => {
		return searchParams.has('startDate') && searchParams.has('endDate');
	}, [searchParams]);

	return readyForQuery;
}
